/**
 * The type of the action which signals that E2EE needs to be enabled / disabled.
 *
 * {
 *     type: TOGGLE_E2EE
 * }.
 */
export const TOGGLE_E2EE = 'TOGGLE_E2EE';
